import React from 'react';
import { ITableDataSource } from 'models/table';
import { Typography } from '@mui/material';
import { useTranslations } from 'hooks/useTranslations';
import { Chips } from 'components/atoms/Chips';
import { Elabels } from 'pages/CaseManagementPage/CasesPage/helpers';
import { StyledTableCard, StyledTableCardItem } from '../../styles';
import { renderStatusCaseFieldColor } from 'pages/CaseManagementPage/helpers';

interface IHistoryTableCard {
  data: ITableDataSource;
}

export const HistoryTableCard = ({ data }: IHistoryTableCard) => {
  const { t } = useTranslations();

  return (
    <StyledTableCard container>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.dateTime)}</Typography>
        <Typography variant="body2">{data.createdDate}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.status)}</Typography>
        <Chips
          text={data.status}
          variant={renderStatusCaseFieldColor({ statusUniqueId: data.statusUniqueId })}
        />
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.description)}</Typography>
        <Typography variant="body2">{data.description}</Typography>
      </StyledTableCardItem>
      <StyledTableCardItem size={{ xs: 12, md: 6 }}>
        <Typography variant="subtitle2">{t(Elabels.user)}</Typography>
        <Typography variant="body2">{data.lastAuthor}</Typography>
      </StyledTableCardItem>
    </StyledTableCard>
  );
};
